
import { useContext } from 'react'
import { type NavigateFunction,type  NavigateOptions,type  To, useNavigate as useRouterNavigate } from 'react-router-dom'
import { Context } from 'src/stores/context'

/**
 * 兼容APP返回上一页/首页，使用jsBridge.system.goBack()
 */
export const useNavigate = (): NavigateFunction => {
  const navigate = useRouterNavigate()
  const { navStackLength } = useContext(Context);
  
  return function nav (to: To | number, option?: NavigateOptions): void | Promise<void> {
    if (typeof to === 'number') {
      // 处理 delta 跳转逻辑
      console.log('Navigating by delta: navStackLength', to, navStackLength);
      navigate(to);
    } else {
      // 处理 to 跳转逻辑
      console.log('Navigating to:', to, option);
      let url = '';
      let search = '';
      // 实际跳转逻辑...
      if (typeof to === 'string') {
        url = to.split('?')[0] || '';
        search = to.split('?')[1] || '';
      } else  {
        url = to.pathname ?? '';
        search = to.search ?? '';
      }
      return navigate(to, option);
    }
  }
}